<template>
  <div class="card" id="Merchant" style="direction: rtl">
    <div class="card-header">
      <h3 class="card-title">پذیرندگان</h3>
      <CButton @click="filter=true" v-if="!filter" style="float: left;margin-left: 10px;margin-top: 10px">
        <CIcon  name="cil-filter" style="width: 30px;height: 30px;float: left;color: white;"/>
      </CButton>
      <CButton @click="[filter=false,GetMerchant(0,10)]" v-else style="float: left;margin-left: 10px;margin-top: 10px">
        <CIcon  name="cil-filter-x" style="width: 30px;height: 30px;float: left;color: white;"/>
      </CButton>
    </div>
    <div class="card-body">
      <CButton class="btn-primary" @click="[DialogAddMerchant=true,]"  style="float: right;margin-left: 10px;margin-top: 10px">
        <CIcon  name="cil-plus" style="width: 15px;height: 15px;float: right;color: white;"/>&ensp;&ensp;<span style="color: white;">افزودن پذیرنده</span>&ensp;&ensp;
      </CButton>
      <CCollapse style="float: right;width: 100%;" :show="filter"  :duration="1000">
        <CCardBody style="float: right;width: 100%;height:200px; background: #2a2b36">
          <div>
            <CRow class="align-items-start" style="direction: rtl">
              <CCol>
                <CInput
                    label="شناسه:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.ID"
                    :is-valid="true"
                />
              </CCol>
              <CCol>
                <CInput
                    label="شماره مرجع:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.Ref"
                    :is-valid="true"
                />
              </CCol>
              <CCol>
                <CInput
                    label="مبلغ:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.Amount"
                    :is-valid="true"
                />
              </CCol>
              <CCol>
                <CInput
                    label="موجودی:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.Balance"
                    :is-valid="true"
                />
              </CCol>

            </CRow>
            <CRow class="align-items-start" style="direction: rtl">
              <CCol>
                <CCol>
                  <CInput
                      label="کارت:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.CartID"
                      :is-valid="true"
                  />
                </CCol>
              </CCol>
              <CCol>
                <CInput
                    label="شماره حساب:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.AccountID"
                    :is-valid="true"
                />
              </CCol>
              <CCol>
                <CInput
                    label="پایانه:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.TerminalID"
                    :is-valid="true"
                />
              </CCol>
              <CCol>
                <CInput
                    label="پذیرنده:"
                    valid-feedback=""
                    invalid-feedback="حداقل شش  کارکتر لاتین"
                    value=""
                    v-model="Filter.MerchantID"
                    :is-valid="true"
                />
              </CCol>

            </CRow>
            <CRow class="align-items-start" style="direction: rtl">

              <CCol>


              </CCol>
              <CCol>
                <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="GetTransactionFilter(0,10)"><span style="float: left;font-size: 18px"> جستجو </span> &nbsp;&nbsp; <CIcon  name="cil-search" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="[Filter.ID='',Filter.Ref='',Filter.Amount='',Filter.Balance='',Filter.CartID='',Filter.AccountID='',Filter.TerminalID='',Filter.MerchantID='',GetTransactionFilter(0,10)]"> <span style="float: left;font-size: 18px">بازنشانی</span> <CIcon  name="cil-action-undo" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="[filter=false,GetTransaction(0,10)]"><span style="float: left;font-size: 18px">بستن</span> <CIcon  name="cil-filter-x" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;

              </CCol>

            </CRow>
          </div>

        </CCardBody>
      </CCollapse>
      <CDataTable
          :hover="true"
          :border="true"
          
          :striped="true"
          :loading="loading"
          :small="true"
          :items="Merchant.data"
          :fields="fieldObject"
          :fixed="true"
          :items-per-page="10"
          pagination
          style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
          :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

      >
        <template #Person="{item}">
          <td>
            {{item.person.per_name+' '+  item.person.per_last_name}}
          </td>
        </template>
        <template #Action="{item}">
          <td>
            <CButton  @click="DeleteReqMerchant(item)"  style="float: left;margin-left: 2px;margin-top: 2px" alt="حذف">
              <CIcon  name="cil-trash" style="width: 30px;height: 30px;float: left;color: white;"/>
            </CButton>
            <CButton   style="float: left;margin-left: 2px;margin-top: 2px" alt="ویرایش">
              <CIcon  name="cil-pen" style="width: 30px;height: 30px;float: left;color: white;"/>
            </CButton>
          </td>
        </template>
        <template #type="{item}">
          <td v-if="item.type">
            {{item.type.mrf_title}}
          </td>
        </template>
      </CDataTable>
      <CPagination
          size="lg"
          style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
          @update:activePage="Change"
          v-if="Merchant.last_page>1"
          :active-page.sync="currentPage"
          :pages="Merchant.last_page"/>
    </div>

    <CModal
        title=""
        color="info"
        :closeOnBackdrop="false"
        :size="'lg'"
        :show.sync="DialogAddMerchant"
    >
      <div style="direction: rtl;text-align: right">
        <CRow>
          <CCol>
            <CInput
                label="نام:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="newMerchant.Name"
                :is-valid="true"
            />
          </CCol>
          <CCol>
            <CInput
                label="نام خانوادگی:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.LastName"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow class="align-items-start" style="direction: rtl">
          <CCol>
            <CInput
                label="کد ملی:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.NationalCode"
                :is-valid="true"
            />
          </CCol>
          <CCol>
            <CInput
                label="نام پدر:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.FatherName"
                :is-valid="true"
            />
          </CCol>
<!--          22009-22014-20109-20088-->
        </CRow>

        <CRow class="align-items-start" style="direction: rtl">
          <CCol>
            <CInput
                label="شماره تلفن:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.PhoneNumber"
                :is-valid="true"
            />
          </CCol>
          <CCol>
            <CInput
                label="شماره ثابت:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.FixedNumber"
                :is-valid="true"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol>
            <CSelect label="نوع:"  size="lg"   :options="TypesOptions"     style="background: black;color: white"  @change="console.log($event.target.selectedIndex)">
            </CSelect>
          </CCol>
          <CCol>
            <CSelect label="بانک:"  size="lg"   :options="BanksOptions"     style="background: black;color: white" @change="indexBank=$event.target.selectedIndex" >
            </CSelect>
          </CCol>
        </CRow>
        <CRow class="align-items-start" style="direction: rtl">
          <CCol>
            <CInput
                label="شماره حساب:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.AccountNumber"
                :is-valid="true"
            />
          </CCol>
          <CCol>
            <CInput
                label="شماره شبا:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.ShabaNumber"
                :is-valid="true"
            />
          </CCol>
        </CRow>

      </div>
      <template #header>

        <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; افزودن شخص </h4>

      </template>
      <template #footer>
        <CButton @click="DialogAddMerchant = false" color="danger">بستن</CButton>
        <CButton  color="primary" @click="AddReqMerchant">&nbsp;&nbsp;  ثبت</CButton>
      </template>
    </CModal>
<!--    <CModal
        title=""
        color="info"
        :closeOnBackdrop="false"
        :size="'md'"
        :show.sync="DialogAddMerchant"
    >
      <div style="direction: rtl;text-align: right">
        <CRow>
          <CCol>
            <CInput
                label="عنوان:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="newMerchant.Title"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow class="align-items-start" style="direction: rtl">
          <CCol>
            <CInput
                label="کد:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="newMerchant.Code"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CSelect label="وضعیت:"  size="lg"   :options="StatusOptions"     style="background: black;color: white" >
            </CSelect>
&lt;!&ndash;            <CInput
                label="وضعیت:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />&ndash;&gt;
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CSelect label="نوع:"  size="lg"   :options="TypesOptions"     style="background: black;color: white"  @change="console.log($event.target.selectedIndex)">
            </CSelect>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <div class="input-group" style="direction: rtl">
              <span  style="width: 100%;color: white;margin-bottom: 5px">انتخاب شخص</span>
              <span v-if="Person" class="form-control" disabled v-text="Person.per_name+' '+Person.per_last_name"   type="text"   aria-describedby="basic-addon1"></span>
              <span v-else class="form-control" disabled v-text=""   type="text"   aria-describedby="basic-addon1"></span>
              <CButton @click="DialogSelectPerson = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
            </div>
          </CCol>
        </CRow>

        <CRow>
          <CCol>
            <CTextarea
                label="توضیحات:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="newMerchant.Desc"
                :is-valid="true"
            />
          </CCol>
        </CRow>
      </div>
      <template #header>

        <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; افزودن شخص </h4>

      </template>
      <template #footer>
        <CButton @click="DialogAddMerchant = false" color="danger">بستن</CButton>
        <CButton  color="primary" @click="AddReqMerchant">&nbsp;&nbsp;  ثبت</CButton>
      </template>
    </CModal>
    <CModal
        title=""
        color="info"
        :closeOnBackdrop="false"
        :size="'md'"
        :show.sync="DialogSelectPerson"
    >
      <div style="direction: rtl;text-align: right">
        <div class="input-group" style="direction: rtl">
&lt;!&ndash;          <span class="input-group-text" style="min-width: 100px">نام  </span>&ndash;&gt;
          <input class="form-control"   type="text"   aria-describedby="basic-addon1">
          <CButton  color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">جستجو</CButton>
        </div>
        <br>
        <CSelect label=""  size="lg" multiple aria-label="Multiple select example" :html-size="10"  :options="PersonOptions" @change="indexPerson=$event.target.selectedIndex"    style="background: black;color: white" >
        </CSelect>
      </div>
      <template #header>

        <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;انتخاب اشخاص </h4>

      </template>
      <template #footer>
        <CButton @click="DialogSelectPerson = false" color="danger">انصراف</CButton>
        <CButton  color="primary" @click="[DialogSelectPerson = false,Person=Persons[indexPerson]]">&nbsp;&nbsp;  انتخاب</CButton>
      </template>

    </CModal>-->
<!--    <CModal
        title=""
        color="info"
        :closeOnBackdrop="false"
        :size="'sm'"
        :show.sync="DialogAddPerson"
    >
      <div style="direction: rtl;text-align: right">
        <CRow class="align-items-start" style="direction: rtl">
          <CCol>
            <CInput
                label="کد:"
                valid-feedback=""
                invalid-feedback=""
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="وضعیت:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="نوع:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CSelect
                label="شخص:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                :options="[1,2,3,4,5,6,7,8,9,10,11,12]"
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="عنوان:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CTextarea
                label="توضیحات:"
                valid-feedback=""
                invalid-feedback="حداقل شش  کارکتر لاتین"
                value=""
                v-model="Filter.ID"
                :is-valid="true"
            />
          </CCol>
        </CRow>
      </div>
      <template #header>

        <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; افزودن شخص </h4>

      </template>
      <template #footer>
        <CButton @click="DialogAddMerchant = false" color="danger">بستن</CButton>
        <CButton  color="primary">&nbsp;&nbsp;  ثبت</CButton>
      </template>
    </CModal>-->


  </div>
</template>

<script>
import Constant from "../../assets/Constants";

export default {
  name: "Merchant",
  data(){
    return {
      filter:false,
      Merchant:[],
      Banks:[],
      newMerchant: {},
      Filter:{
        ID:"",
        Code:"",
        Status:"",
        Type:"",
        Person:"",
        Title:"",
        RegisterDate:"",
        UpdateDate:"",
      },
      StatusOptions:[],
      TypesOptions:[],
      BanksOptions:[],
      loading:false,
      edit:false,
      PersonOptions:[],
      DialogAddMerchant:false,
      DialogAddPerson:false,
      indexPerson:-1,
      indexBank:-1,
      indextype:0,
      Persons:[],
      Person:null,
      DialogSelectPerson:false,
      fieldObject:[{key:'mer_id',label:'شناسه'},{key:'mer_code',label:'کد'},{key:'mer_state',label:'وضعیت'},{key:'Person',label:'نام و نام خانوادگی'},{key:'mer_title',label:'عنوان'},{key:'mer_description',label:'توضیحات'},{key:'mer_creation_date',label:'تاریخ'},{key:'mer_creation_date',label:'تاریخ'},{key:'Action',label:'عملیات'}],
      currentPage:1,
    }
  },
  mounted() {
    this.GetMerchant(1,10);
    this.GetPerson();
    this.GetMerchantType();
    this.GetBanks();
  },
  methods:{
    GetMerchant(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.Merchant;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Merchant=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{
            that.loading=false;

          } );
    },
    GetBanks(){
      var that=this;
      this.axios
          .get("http://85.15.46.129:10354/cms-1.0-SNAPSHOT/rest/api/banks")
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Banks=data;
            for (var i=0;i<this.Banks.length;i++){//item.person.per_last_name
              that.BanksOptions.push({label: this.Banks[i]. name,value:this.Banks[i].id})
            }
          }).catch(function (error) {
              console.log(error);
           })
          .finally(() =>{


          } );
    },
    AddReqMerchant(){
      if(this.indexBank===-1){
        this.indexBank=0;
      }
    //  console.log(this.Banks[this.indexBank].id)
      var url="http://85.15.46.129:10354/cms-1.0-SNAPSHOT/rest/api/merchants";
      var that=this;
      this.axios
          .post(url,{
            name:this.newMerchant.Name,
            last_name:this.newMerchant.LastName,
            national_code:this.newMerchant.NationalCode,
            father_name:this.newMerchant.FatherName,
            mobile:this.newMerchant.PhoneNumber,
            phone:this.newMerchant.PhixedBumber,
            type:'natural',
            bank_account_info:{
              bank_id:this.Banks[this.indexBank].id,
              no:this.newMerchant.AccountNumber,
              iban:this.newMerchant.ShabaNumber,
            }
          })
          .then(response => {
            that.Loading = false
            var data=response.data;
            that.DialogAddMerchant=false;
            that.GetMerchant(this.currentPage,10);

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

          } );
    },
    DeleteReqMerchant(item){
      console.log(this.indextype)
      var url=Constant.AddMerchant+"/"+item.mer_id;
      var that=this;
      this.axios
          .delete(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            that.DialogAddMerchant=false;
            that.GetMerchant(this.currentPage,10);

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

          } );
    },
    GetPerson(){
      this.loading=true;
      var url=Constant.Person;
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data);
            that.Persons=data.data;
            for (var i=0;i<data.data.length;i++){//item.person.per_last_name
              that.PersonOptions.push({label:  (data.data[i].per_name+" "+data.data[i].per_last_name),value:data.data[i]})
            }
          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{
            that.loading=false;

          } );
    },
    GetMerchantType(){
      this.loading=true;
      var url=Constant.MerchantType;
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data);
            that.Persons=data.data;
            for (var i=0;i<data.data.length;i++){//item.person.per_last_name
              that.TypesOptions.push({label: data.data[i]. mrf_title,value:data.data[i].mrt_id})
            }
          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{
            that.loading=false;

          } );
    },
    GetTransactionFilter(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionSearch;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      if(this.Filter.ID.length!==0){
        url+="trn_id%3D%3D"+this.Filter.ID+"%3B";
      }
      if(this.Filter.Ref.length!==0){
        url+="trn_ref_number%3Dlk%3D"+this.Filter.Ref+"%3B";
      }
      if(this.Filter.Amount.length!==0){
        url+="trn_amount%3D%3D"+this.Filter.Amount+"%3B";
      }
      if(this.Filter.Balance.length!==0){
        url+="trn_balance%3D%3D"+this.Filter.Balance+"%3B";
      }
      if(this.Filter.CartID.length!==0){
        url+="trn_card_id%3Dlk%3D"+this.Filter.CartID+"%3B";
      }
      if(this.Filter.AccountID.length!==0){
        url+="trn_account_id%3Dlk%3D"+this.Filter.AccountID+"%3B";
      }
      if(this.Filter.TerminalID.length!==0){
        url+="trn_terminal_id%3D%3D"+this.Filter.TerminalID+"%3B";
      }
      if(this.Filter.MerchantID.length!==0){
        url+="trn_merchant_id%3D%3D"+this.Filter.MerchantID;
      }
      if(url.substr(url.length-3,url.length)==="%3B"){
        url=url.substr(0,url.length-3);
      }
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Transaction=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

            that.loading=false;
          } );
    },
    Change(val,val2){
      console.log("OK --> ",val,val2);
      if(this.filter){
        this.GetTransactionFilter(val,10);
      }else {
        this.GetTransaction(val,10);
      }

    }
  }
}
</script>

<style scoped>

</style>